import { satisfaccion_catalog } from "../../../../escalas/satisfaccion/satisfaccion_catalog"
import { satisfaccion_2_catalog } from "../../../../escalas/satisfaccion_2/satisfaccion_2.catalog"

export default function SatisfaccionResults({ satisfaccion }) {
    const respuestas_radio = ["Completamente en desacuerdo", "En desacuerdo", "Neutral", "De acuerdo", "Totalmente de acuerdo"]
    const respuestas_seleccion = ["No", "Si"]

    const getRespuesta = (item, resp) => {
        if (item.tipo === 'radioButton') {
            return respuestas_radio[resp]
        }
        if (item.tipo === 'seleccion') {
            return resp
        }
        if (item.tipo === 'texto') {
            return resp
        }
    }
    return (
        <div>
            {/* {JSON.stringify(satisfaccion)} */}
            {
                satisfaccion_2_catalog.map((item, index) => (
                    <tr key={index} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', backgroundColor: index % 2 === 0 ? '#f5f5f5' : '#fff', padding: 5, borderRadius: 6 }}>
                        <td>{item["label"]}</td>
                        {/* <td>{satisfaccion[index]}</td> */}
                        <td>{getRespuesta(item, satisfaccion[index])}</td>
                    </tr>
                ))
            }
        </div>
    )
}